// Oturumla ilgili tüm localStorage anahtarları tek yerde silinir.
// b/k/s: kaldırılan "Beni Hatırla" özelliğinin eski sürümlerde yazdığı anahtarlar
// (k/s kullanıcı adı ve DÜZ METİN parola) — eski tarayıcı verisini temizlemek için burada kalır.
const SESSION_KEYS = [
  'accessToken',
  'userData',
  'userAbility',
  'salespersonBaseToken',
  'rawItems',
  'b',
  'k',
  's',
]

export const clearSession = () => {
  SESSION_KEYS.forEach(key => localStorage.removeItem(key))
}

// Kaldırılan "Beni Hatırla" özelliğinin bıraktığı düz metin parolayı her açılışta siler.
export const clearLegacyRememberMe = () => {
  ;['b', 'k', 's'].forEach(key => localStorage.removeItem(key))
}
